import {
  Button,
  LinearProgress,
  Grid,
  Box,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import withServices from "../../hocs/withServices";
import { useAlert } from "../../hooks/useAlert";

function FileUpload({
  services,
  helperText,
  fileType,
  file,
  filePath,
  handleSetFileId,
  handleDelete,
  disabled,
  multiple = false,
}) {
  const [progress, setProgress] = useState(0);
  const showAlert = useAlert();

  const handleFileDownload = (i) => {
    if (multiple) {
      services.fileUpload.getDocument(file[i], filePath[i].split("/").pop());
    } else {
      services.fileUpload.getDocument(file, filePath.split("/").pop());
    }
  };

  const deleteFile = () => {
    services.fileUpload.deleteFile(file, null)
      .then(response => {
        showAlert('Успешно удален!', 'success')
      })
      .catch(error => {
        showAlert(error.response.data.message, 'error')
      })
      .finally(() => {
        handleDelete()
      })
  }

  const handleFileChange = (event) => {
    const [file] = event.target.files;

    const callback = (progress) => {
      setProgress(progress === 100 ? 0 : progress);
    };
    if (multiple) {
      let files = [];
      for (let file of event.target.files) {
        files.push(file);
      }
      files.reverse();
      services.fileUpload
        .uploadDocuments(files, fileType, callback)
        .then((response) => {
          showAlert('Успешно загружен! Не забудьте нажать кнопку "сохранить"', 'success')
          handleSetFileId(response.data);
        })
        .catch((error) => {
          showAlert(error.response.data.message, 'error')
        })
        .finally(() => (event.target.value = null));
    } else {
      services.fileUpload
        .uploadDocument(file, fileType, callback)
        .then((response) => {
          showAlert('Успешно загружен! Не забудьте нажать кнопку "сохранить"', 'success')
          handleSetFileId(response.data);
        })
        .catch((error) => {
          showAlert(error.response.data.message, 'error')
        })
        .finally(() => (event.target.value = null));
    }
  };

  const fileDownloadBtn = () => {
    if (multiple) {
      return (
        file &&
        filePath &&
        Object.keys(file).map((file, i) => (
          <Grid item xs={12}>
            <Grid container justify="center">
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleFileDownload(i)}
                fullWidth
              >
                Скачать ранее загруженный документ ({helperText + " " + (i + 1)}
                )
              </Button>
            </Grid>
          </Grid>
        ))
      );
    } else {
      return (
        file &&
        filePath && (
          <Grid item xs={12}>
            <Grid container justify="center">
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleFileDownload()}
                fullWidth
              >
                Скачать ранее загруженный документ ({helperText})
              </Button>
            </Grid>
            <Grid container justify="center" style={{ marginTop: 20 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => deleteFile()}
                fullWidth
              >
                Удалить файл
              </Button>
            </Grid>
          </Grid>
        )
      );
    }
  };

  return (
    <Grid container spacing={2}>
      {fileDownloadBtn()}
      {progress > 0 && (
        <Grid item xs={12}>
          <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
              <LinearProgress variant="determinate" value={progress} />
            </Box>
            <Box minWidth={35}>
              <Typography variant="body2" color="textSecondary">
                {Math.round(progress)}%
              </Typography>
            </Box>
          </Box>
        </Grid>
      )}
      {/* {showError && (
        <div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="warning"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Не удалось загрузить файл, попробуйте загрузить другой тип файла!
            </Alert>
          </Snackbar>
        </div>
      )}
      {showSuccess && (
        <div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="success"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Файл был успешно загружен на сервер. Не забудьте нажать кнопку
              "Сохранить"
            </Alert>
          </Snackbar>
        </div>
      )} */}
      <Grid item xs={12}>
        {/* <Button
          variant='outlined'
          type='file'
          onClick={event => handleFileChange(event)}
          // label={helperText}
          // InputLabelProps={{ shrink: true }}
          // fullWidth
          disabled={disabled}
        // inputProps={{
        //   multiple: multiple
        // }}
        >Загрузите файл</Button> */}
        <Button
          variant="outlined"
          component="label"
          disabled={disabled}
          fullWidth
        >
          {((Array.isArray(file) && file.length > 0) || (file !== undefined && file.length !== 0)) &&
            ((Array.isArray(filePath) && filePath.length > 0) ||
              filePath !== undefined)
            ? `Обновить ${helperText}` : `Загрузить ${helperText}
            (максимальный размер файла - 15 мб)`}
          <input
            type="file"
            hidden
            {...(multiple ? { multiple: true } : {})}
            onChange={(event) => handleFileChange(event)}
          />
        </Button>
      </Grid>
    </Grid>
  );
}

FileUpload.defaultProps = {
  disabled: false,
};

export default withServices()(FileUpload);
